export const ParentEvents = {
	ParentUrl: 'Parent.location',
	IFrameAttribute: 'Parent.attribute',
	ResizeFrame: 'Parent.resize',
	FireGTM: 'Parent.gtm',
	PostRequest: 'Parent.postRequest',
	UploadRequest: 'Parent.uploadRequest',
	GetRequest: 'Parent.getRequest',
	FontColor: 'Parent.fontColor',
	WindowSize: 'Parent.windowSize',
};
